(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxLocalizationEditor', {
		bindings: {
			localizedValue: '=',
			supportedLanguages: '<?',
			dialog: '=',
			result: '=',
			title: '@?',
			saveLocalizationDirectly: '@',
			richTextMode: '=',
			richTextModeOptions: '=?',
			activeMode: '@',
			customEditor: '<?',
		},
		controller: MxLocalizationEditorCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-localization-editor/mx-localization-editor.html',
	});

	MxLocalizationEditorCtrl.$inject = ['$timeout', 'mx.internationalization', 'mx.SolutionBuilderAgent.TranslationService'];

	function MxLocalizationEditorCtrl($timeout, i18n, translationService) {
		var vm = this;

		vm.$onInit = function () {
			vm.richTextModeOptions = vm.richTextModeOptions || {};
			vm.errors = [];
			vm.hideClick = function () {
				vm.result.reject();
				vm.dialog.hide();
			};

			var saveMode = vm.saveLocalizationDirectly === 'true';
			vm.saveButtonText = i18n.get('solutionBuilderAgent.components.mx-localization-editor.' + (saveMode ? 'save' : 'ok'));

			vm.saveClick = function () {
				if (!vm.localizedValue.id || !vm.prepareProperty) {
					return;
				}

				var property = vm.prepareProperty(vm.localizedValue.id);

				if (!property) {
					return;
				}

				if (saveMode) {
					translationService.updateLocalizationString(property);
				}
				// Timeout added because Tinymce needs time to update ng-model (blur time). Without timeout latest value can be lost.
				$timeout(function () {
					vm.result.resolve(property);
					vm.dialog.hide();
				}, 400);
			};
		};

		return vm;
	}
})();
